import { ref } from 'vue';
import ConversationAPI from '@/api/conversation';

export function useConversation(reportId) {
  const messages = ref([]);
  const loading = ref(false);

  const fetchConversation = async () => {
    try {
      loading.value = true;
      const response = await ConversationAPI.getConversation(reportId);
      messages.value = response.messages || [];
    } catch (error) {
      console.error("Failed to fetch conversation:", error);
    } finally {
      loading.value = false;
    }
  };

  const sendMessage = async (messageContent) => {
    if (loading.value) return;

    try {
      loading.value = true;

      // Add user message optimistically
      const tempUserMessage = {
        id: Date.now(),
        role: "user",
        content: messageContent,
      };
      messages.value.push(tempUserMessage);

      // Send to API and get response
      const response = await ConversationAPI.sendMessage(reportId, messageContent);

      // Update with real IDs from server
      const lastIndex = messages.value.length - 1;
      messages.value[lastIndex] = response.user_message;
      messages.value.push(response.assistant_message);
    } catch (error) {
      console.error("Failed to send message:", error);
      // Remove optimistic message on error
      messages.value.pop();
    } finally {
      loading.value = false;
    }
  };

  return {
    messages,
    loading,
    fetchConversation,
    sendMessage
  };
}